import React from "react"
import { Confirm } from "../../../../../../Common/Modal/Confirm"

interface CannotCreateQualifierModalProps {
    onClose: () => void
}

export function CannotCreateQualifierModal({
    onClose
}: CannotCreateQualifierModalProps) {
    return (
        <Confirm
            title="No baseline data to create qualifier"
            description="Add ground-truth data to create a qualifier"
            yesLabel="Ok"
            onClickYes={onClose}
            onClose={onClose}
        />
    )
}
